/**************************************************
 * Nombre:       Detalle_Producto_Img_Caracteristicas_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Box, Button, Chip, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {TrendingFlat} from '@mui/icons-material'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politicas from "../../Dialogos/Dialogo_Politicas";
import {NEGRITA} from "../../../Constantes";
import {useCantidadBotones} from "../../../Modulo_Carrito_Compra/Hooks/useCantidadBotones";
import {useTabsEspecificaciones} from "../../../Modulo_Carrito_Compra/Hooks/useTabsEspecificaciones";
import envio from '../../../Recursos/Iconos/ic_pol_envio.svg'
import cambio from '../../../Recursos/Iconos/ic_pol_cambios.svg'
import logos from '../../../Recursos/logos_envios.png'
import {formatoMoneda} from "../../../Utilidades/formatoMoneda";
import {obtenerPorcentaje} from "../../../CodCliente/obtenerPorcentaje";
import Lightbox from "yet-another-react-lightbox";
import {useFuncionesCarritoLateral} from "../../../Modulo_Carrito_Lateral/Hooks/useFuncionesCarritoLateral";
import {adap_producto_carrito_lateral} from "../../../Modulo_Carrito_Lateral/Adaptadores/adap_producto_carrito_lateral";
import {useCarritoLateral} from "../../../Modulo_Carrito_Lateral/Hooks/useCarritoLateral";
import {useNavigate} from "react-router";
import fondo_nohay from '../../../Recursos/fondo_tachado.svg'

const Detalle_Producto_Img_Caracteristicas_Caracteristicas = ({producto}) => {
    const {sCell, masSM} = useResponsive()
    const cData = useContext(contexApp)
    const navigate = useNavigate()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politicas})
    const {Botones} = useCantidadBotones({producto: producto})
    const {TabsEspecificaciones} = useTabsEspecificaciones({items: producto.informaciones})
    const {adicionarProducto} = useFuncionesCarritoLateral()
    const {Carrito, abrir: abrirCarrito,} = useCarritoLateral()
    const [etiquetas, setEtiquetas] = useState([])
    const [open, setOpen] = useState(false);
    const [escogida, setEscogida] = useState('')
    const [configuraciones, setConfiguraciones] = useState({})
    const [cargando, setCargando] = useState(false)


    const agregarProducto = (cant) => {
        setCargando(true)

        let prod = adap_producto_carrito_lateral({
            producto: producto,
            cantidad: cant,
            variacion: {nombre: escogida}
        })
        //Deberia ir aqui el pixel

        window.fbq('track', 'AddToCart', {
            content_ids: [prod.nombre],
            content_type: 'product',
            value: prod.valor,
            currency: 'COP'
        });

        adicionarProducto(prod)

        setTimeout(() => {
            abrirCarrito()
            setCargando(false)
        }, 1500)
    }

    const clickComprar = (cant) => {
        setCargando(true)

        let prod = adap_producto_carrito_lateral({
            producto: producto,
            cantidad: cant,
            variacion: {nombre: escogida}
        })
        adicionarProducto(prod)
        navigate('/Checkout')


        setTimeout(() => {
            setCargando(false)
        }, 1500)
    }


    const click = (id) => {

        switch (id) {
            case 'compra':
                abrir({texto: configuraciones.politica_envio})
                break
            case 'datos':
                abrir({texto: configuraciones.politica_protenccion})
                break
        }
    }

    useEffect(() => {


        let arrEti = []

        if (producto.valorAntes > 0) {
            let descuento = obtenerPorcentaje({valor: producto.valor, rebajado: producto.valorAntes});
            arrEti.push(descuento + '%');
        }


        if (producto.etiquetas) {
            arrEti.push(...producto.etiquetas);
        }

        setEtiquetas(arrEti)

        if (producto.variaciones && producto.variaciones.length > 0) {
            setEscogida(producto.variaciones[0].nombre)
        }

        if (cData.configuraciones && cData.configuraciones.length > 0) {
            setConfiguraciones(cData.configuraciones[0])
        }

    }, [producto, cData])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                color: theme.palette.primary.main,
                position: 'sticky',
                top: 40

            }}
        >

            <Dialogo/>

            <Carrito/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{px: 0.5}}>
                <Typography sx={{
                    fontSize: !masSM ? 16 : 18,
                    fontWeight: 400
                }}>{producto.coleccion && producto.coleccion.toUpperCase()}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography
                    sx={{fontSize: !masSM ? 32 : 40, fontFamily: NEGRITA, fontWeight: 600, lineHeight: 1}}>
                    {producto.nombre && producto.nombre.toUpperCase()}
                </Typography>
            </Grid>

            {producto && producto.valorAntes > 0 &&
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                    <Typography sx={{
                        fontSize: 12,
                        fontWeight: 300,
                        lineHeight: 1.3,
                        color: '#8D8D8D'
                    }}>
                        {`ANTES ${formatoMoneda(producto.valorAntes)}`}
                    </Typography>
                </Grid>
            }


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0, alignItems: 'center'}}
                  spacing={1}
            >
                <Typography sx={{
                    fontSize: 26,
                    fontWeight: 300,
                    lineHeight: 1.3,
                }}>
                    {formatoMoneda(producto.valor)}
                </Typography>

                {etiquetas.map((item, index) => (
                    <Chip color={'primary'} label={item} size={'small'}/>
                ))}


            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 4}}
                spacing={2}
            >


                {producto.variaciones && producto.variaciones.map((item, index) => {

                   if (item.cantidad && parseInt(item.cantidad) > 0){
                       return (
                           <Box
                               onClick={() => setEscogida(item.nombre)}
                               sx={{
                                   border: 1,
                                   borderColor: '#000',
                                   px: 4, pt: 0.2, pb: 0.1,
                                   backgroundColor: escogida === item.nombre ? '#000' : 'white',
                                   color: escogida === item.nombre ? '#fff' : '#000',
                                   cursor: 'pointer',
                               }}>
                               <Typography>{item.nombre}</Typography>
                           </Box>
                       )
                   }else{
                       return (
                           <Box
                              // onClick={() => setEscogida(item.nombre)}
                               sx={{
                                   border: 1,
                                   borderColor: '#00000060',
                                   px: 4, pt: 0.2, pb: 0.1,
                                   backgroundImage: `url(${fondo_nohay})`,
                                   backgroundSize: 'cover',
                                   backgroundRepeat: 'no-repeat',
                                   backgroundPosition: 'center center',
                                   color: '#00000080',
                                   cursor: 'pointer',
                               }}>
                               <Typography>{item.nombre}</Typography>
                           </Box>
                       )
                   }



                })}

            </Grid>

            <Grid container size={12} sx={{mt: 2}}>
                <Typography
                    onClick={() => setOpen(true)}
                    sx={{borderBottom: 1, cursor: 'pointer', fontSize: 12, color: '#00000090'}}>GUIA DE
                    TALLAS <TrendingFlat
                        sx={{pl: 1, mt: 0.5, mb: -0.6, width: 20, height: 20}}/></Typography>

                <Lightbox
                    open={open}
                    close={() => setOpen(false)}
                    slides={[{
                        src: producto.imgGuia
                    }]}
                />

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Botones varianteEscogida={escogida} clickAgregar={agregarProducto} clickComprarAhora={clickComprar}
                         cargando={cargando}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <TabsEspecificaciones item={producto}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}} spacing={!masSM ? 2 : 4}>
                <Button
                    onClick={() => click('compra')}
                    variant={'text'} startIcon={<img src={envio} width={16} height={'auto'}/>}
                    sx={{px: 1, textTransform: 'none', fontSize: 12, fontWeight: 400}}
                >POLITICAS DE ENVIO</Button>

                <Button
                    onClick={() => click('datos')}
                    variant={'text'} startIcon={<img src={cambio} width={16} height={'auto'}/>}
                    sx={{px: 1, textTransform: 'none', fontSize: 12, fontWeight: 400}}
                >POLITICAS DE PRIVACIDAD</Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', borderTop: 1, pt: 4, mt: 4}}>
                <img src={logos} width={'90%'} height={'auto'}/>
            </Grid>


        </Grid>
    )

}
export default Detalle_Producto_Img_Caracteristicas_Caracteristicas